export default __webpack_public_path__ + "static/media/logo05.7ac13b89.svg";